import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './memory.json'; // The JSON you provided

const Memory = () => {
  return (
    <div className="topic-page-container">
        {/* We can still use your Layout, but we pass the Router as children or a prop */}
        <TopicsPageLayout
            
            description="Exercises on memory techniques, cognitive science, and remembering vocabulary. B2 level grammar, reading, and vocabulary practice."
            level="B2"
            title="Memory"
            image="/Images/memory.webp"
            seoTitle="Free English Lesson Plans: Memory"
            seoDescription="Exercises on memory techniques, cognitive science, and remembering vocabulary. B2 level grammar, reading, and vocabulary practice."
        >
            {/* Map through the JSON and render everything immediately */}
            
                {topicData.map((section, index) => (
                    <div key={index} className="lesson-section-wrapper">
                        <TopicsRouter sectionData={section} />
                    </div>
                    ))}
            
        </TopicsPageLayout>
    </div>
  );
};

export default Memory;
